import { mediaItems } from '@/mocks/movies';

export default function Media() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            影视解说
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            深度解读热门影片，带你发现被窝影院电影大全免费看的隐藏好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#hero"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-200">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-foreground-900/60 backdrop-blur-sm text-background-50 group-hover:bg-primary-500 transition-colors duration-300">
                    <i className="ri-play-fill text-xl md:text-2xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-1 bg-foreground-900/70 backdrop-blur-sm rounded text-xs text-background-50">
                  {item.duration}
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-sm md:text-base font-bold text-foreground-900 mb-1.5 line-clamp-2">
                  {item.title}
                </h3>
                <span className="text-xs text-foreground-500">{item.views} 次观看</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}